import { Reducer } from 'redux'
import { IVolumewaardeState } from '../interfaces'
import { VolumewaardeActions, Actions } from '../actions/volumewaardenAction'

const initialState: IVolumewaardeState = {
  loading: false,
  foutmelding: undefined,
  volumewaarden: undefined,
}

export const volumewaardenReducer: Reducer<
  IVolumewaardeState,
  VolumewaardeActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetVolumewaardeRequest:
      return { ...state, loading: true, volumewaarden: null, foutmelding: null }
    case Actions.GetVolumewaardeResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        volumewaarden: action.success ? action.payload : [],
      }
    case Actions.PostVolumewaardeRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.PostVolumewaardeResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
      }
    case Actions.DeleteVolumewaardeRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.DeleteVolumewaardeResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
      }
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
